import { render, staticRenderFns } from "./GroupDropdown.vue?vue&type=template&id=25aab6ea&"
import script from "./GroupDropdown.vue?vue&type=script&lang=js&"
export * from "./GroupDropdown.vue?vue&type=script&lang=js&"
import style0 from "./GroupDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports